export const BREAKPOINTS = {
  laptop: 1024,
  tablet: 768,
  mobileL: 600,
  mobileM: 375,
  mobileS: 320,
};
